export default "/icon-close.svg";